import { createCachedSelector, defaultKeySelector, path } from '@cbridge-utils/redux';
import { AlertType } from '@cbridge-packages/alert';
import { searchFilterSelector } from '@cbridge-modules/search-filter';
import { alertSubscriptionStoreSelector } from '../../alertSubscription.selector';
import { isSubscriptionLoading } from '../../_selectors/isSubscriptionLoading.selector';
import { availableAlertSubscriptionsSelector } from '../../_selectors/availableAlertSubscriptions.selector';
import { IEmailRecipient } from './AlertEmailRecipients.interface';

export const alertEmailRecipientsDataGridPropsSelector = createCachedSelector(
  [
    path(alertSubscriptionStoreSelector).emails(),
    availableAlertSubscriptionsSelector,
    isSubscriptionLoading,
    searchFilterSelector,
  ],
  (emails, subscriptions, isLoading, search) => {
    const alertTypes: AlertType[] = subscriptions.map(sub => sub.type);

    const dynamicDefaultSubscriptions = alertTypes.reduce((acc, alertType) => {
      acc[alertType] = false;
      return acc;
    }, {} as Record<AlertType, boolean>);

    const searchLc = search?.trim().toLowerCase();
    const filteredEmails = searchLc
      ? emails.filter((email) => email.toLowerCase().includes(searchLc))
      : emails;

    const emailRecipientsMap: Record<string, IEmailRecipient> = filteredEmails.reduce((acc, email) => {
      acc[email] = {
        email,
        subscriptions: { ...dynamicDefaultSubscriptions },
      };
      return acc;
    }, {});

    subscriptions.forEach(({ recipients, type }) => {
      recipients.forEach((email) => {
        const recipient = emailRecipientsMap[email];

        if (recipient) {
          recipient.subscriptions[type] = true;
        }
      });
    });

    return {
      recipients: Object.values(emailRecipientsMap),
      alertTypes,
      isLoading,
    };
  },
)({
  keySelector: defaultKeySelector,
});
